// Pure helpers for the Adaptive Test schedule (see src/adaptiveTest/data.js).
// Dates are "YYYY-MM-DD" strings, so they compare correctly as strings.

const istDate = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Kolkata",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

// Built from the date parts: the whole-date format of en-CA has changed between browser versions.
export function todayInIST(now = new Date()) {
  const part = {};
  istDate.formatToParts(now).forEach(({ type, value }) => (part[type] = value));
  return `${part.year}-${part.month}-${part.day}`;
}

export function upcomingSessions(sessions, today) {
  return sessions
    .filter((session) => session.date >= today)
    .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
}

// One entry per slot at each centre on each upcoming date: { date, name, city, address, slot }.
export function upcomingSlots(sessions, today) {
  return upcomingSessions(sessions, today).flatMap((session) =>
    session.centres.flatMap(({ slots, ...centre }) =>
      slots.map((slot) => ({ date: session.date, ...centre, slot }))
    )
  );
}

const displayDate = new Intl.DateTimeFormat("en-GB", {
  timeZone: "UTC",
  day: "numeric",
  month: "short",
  year: "numeric",
});

export function formatSessionDate(date) {
  return displayDate.format(new Date(`${date}T00:00:00Z`));
}

const ordinal = (day) => {
  if (day > 3 && day < 21) return "th";
  return { 1: "st", 2: "nd", 3: "rd" }[day % 10] || "th";
};

// Same wording as the Book Your Test cards in JoinUs.js, e.g. "Saturday, 7th November, 2026".
export function formatLongDate(date) {
  const d = new Date(`${date}T00:00:00Z`);
  const part = (options) => d.toLocaleString("en-GB", { timeZone: "UTC", ...options });
  const day = d.getUTCDate();
  return `${part({ weekday: "long" })}, ${day}${ordinal(day)} ${part({ month: "long" })}, ${d.getUTCFullYear()}`;
}

// Fee wording used everywhere the Adaptive Test fee is shown, e.g. "₹2000 + GST".
export function formatFee(fee) {
  return `₹${fee} + GST`;
}
